import { StyleSheet } from 'react-native';

import { Fonts } from '@vfgroup-oneplatform/foundation/Components/Themes';

export default StyleSheet.create({
  fullSpecsContainer: {
    paddingHorizontal: 16,
    marginTop: 30,
  },
  fullSpecsItemList: {
    paddingTop: 10,
    paddingBottom: 60,
  },
  fullSpecsItem: {
    marginBottom: 15.6,
    paddingRight: 20,
  },
  fullSpecsName: {
    ...Fonts.type.bold,
    fontSize: 18.7,
    lineHeight: 25,
    marginBottom: 16.6,
  },
  fullSpecsItemValuesContainer: {
    display: 'flex',
    flexDirection: 'row',
  },
  fullSpecsItemValuesIcon: theme => ({
    width: 7,
    height: 7,
    borderRadius: 3.5,
    marginTop: 8,
    marginBottom: 8,
    marginLeft: 12,
    marginRight: 20,
    backgroundColor: theme.colors.text.primary,
    alignItems: 'center',
  }),
  fullSpecsItemValuesTxt: {
    fontSize: 16.6,
    lineHeight: 23,
    marginRight: 16,
  },
});
